import { KYMW9008Component } from './kymw9008.component';

/**
 * 2要素認証画面の値を管理するクラス
 *
 * @export KYMW9008Model
 * @class KYMW9008Model
 */
export class KYMW9008Model {
  kYMW9008Component: KYMW9008Component;

  // 認証コード
  public emailOtpCode: string = '';
}
